import React from 'react';
import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import Container from './Container';
import site from '../../config/site';

export default function QuoteCallToAction({
  title = '¿Necesita una solución personalizada?',
  description = 'Nuestro equipo de ingeniería está listo para evaluar su proyecto.',
  buttonLabel = 'Solicitar evaluación',
  href = '/contact',
  whatsappMessage,
  contactReference,
}) {
  const reference = contactReference || {
    type: 'solution',
    title,
    description,
  };

  return (
    <Box as="section" bg="brand.700" py={{ base: 12, md: 16 }}>
      <Container>
        <Stack
          direction={{ base: 'column', lg: 'row' }}
          align={{ base: 'flex-start', lg: 'center' }}
          justify="space-between"
          spacing={{ base: 6, lg: 10 }}
        >
          <Box>
            <Heading as="h2" size="h3" color="text.inverse">
              {title}
            </Heading>
            <Text color="whiteAlpha.900" mt={2}>
              {description}
            </Text>
          </Box>
          <Stack
            direction={{ base: 'column', sm: 'row' }}
            spacing={3}
            w={{ base: 'full', sm: 'auto' }}
            flexShrink={0}
          >
            <Button
              as={RouterLink}
              to={href}
              state={{ contactReference: reference }}
              bg="white"
              color="brand.700"
              _hover={{ bg: 'brand.100' }} w={{ base: 'full', sm: 'auto' }}>
              {buttonLabel}
            </Button>
            <Button
              as="a"
              href={site.whatsapp.href(whatsappMessage)}
              target="_blank"
              rel="noopener noreferrer"
              variant="whatsapp"
              leftIcon={<FaWhatsapp aria-hidden="true" />}
              w={{ base: 'full', sm: 'auto' }}
            >
              WhatsApp
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
